export default {
      id: "logo--text-usage",
      viewBox: "0 0 230 53",
      url: "../../assets/" + "sprite.svg#logo--text-usage",
      toString: function () {
        return this.url;
      }
    }